export default __webpack_public_path__ + "static/media/01_abnormal.599a4564.gif";